import { AGGREGATOR_BASE_URL } from 'src/environments/base-url';

export const gameStrategiesBulkUploadUrl = (): string => `${AGGREGATOR_BASE_URL}/games/strategies/bulk`;
